import { classNamez } from "@tecreation/funnel-components"
import "./MyParadiseOverviewButton.css"
export const MyParadiseOverviewButton = ({ children, className, half, label, labelOnClick }) => {
	return (
		<div
			className={
				"myParadiseOverviewButton clickable mt-3 rounded-3 flex flex-column " + className + classNamez({ "w-25": half, "w-100": !half, "flex-1": !half })
			}
		>
			<div className="rounded-3 of-y-hidden flex-1">{children}</div>
			<div className="text-center color-fg-secondary" onClick={labelOnClick}>
				{label}
			</div>
		</div>
	)
}
